export const FETCH_SUPPORTED_CURRENCIES = 'FETCH_SUPPORTED_CURRENCIES';
export const FETCH_SUPPORTED_CURRENCIES_SUCCESS = 'FETCH_SUPPORTED_CURRENCIES_SUCCESS';
export const FETCH_SUPPORTED_CURRENCIES_FAILURE = 'FETCH_SUPPORTED_CURRENCIES_FAILURE';
export const CLEAR_SUPPORTED_CURRENCIES = 'CLEAR_SUPPORTED_CURRENCIES';
